module.exports = __webpack_public_path__ + "static/media/beaconTrainingHeader.cd12ab6e.jpg";